import { useGetOrganizationsQuery, OrganizationState } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import {
    organizationsColumns,
    type OrganizationRow,
    type OrganizationFilterInput,
} from '../constants/organizationsColumns';

const defaultFilters: Partial<OrganizationFilterInput> = {
    state: [OrganizationState.Rollout],
};

export const OrganizationsList = () => {
    const {
        loading: organizationsLoading,
        data: organizationsData,
        error: organizationsError,
    } = useGetOrganizationsQuery();

    if (organizationsLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!organizationsData || organizationsError) {
        throw new Error('Une erreur est survenue lors de la récupération des organisations');
    }

    const { organizations } = organizationsData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<OrganizationRow, OrganizationFilterInput>
                columns={organizationsColumns}
                data={organizations}
                defaultFilters={defaultFilters}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/organization/${row._id}`}
                searchPlaceholder="Nom de l'organisation"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
